import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { YesNoQuestion } from './yes-no-question/YesNoQuestion';
import { UsePremiumStarterKitQuestion } from './UsePremiumStarterKitQuestion';
import { useRootStore } from '../../root/RootStoreHooks';
import { MeoWarning } from './MeoWarning';

const ErYesMessage = () => {
  const { t } = useTranslation();
  return (
    <>
      <span dangerouslySetInnerHTML={{ __html: t('EssentialRewardsIfYes') }} />
       {' '}
      <a
        href={
          t('EssentialRewardsTermsAndConditionsUrl') ||
          'https://static.youngliving.com/en-US/PDFS/ER_Agreement_Terms_and_Conditions_en_US.pdf'
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        {' '}
        {t('EssentialRewardsTermsAndConditions')}{' '}
      </a>

      <span dangerouslySetInnerHTML={{ __html: t('EssentialRewardsYouMayCancelAnyTime') }} /> 
    </>
  );
};

const ErYesMessageNoLink = () => {
  const { t } = useTranslation();
  return <>{t('EssentialRewardsIfYes')} </>;
};

export const EnrollEssentialRewardsQuestion = observer(() => {
  const { t } = useTranslation();
  const root = useRootStore();
  const erKitStore = root.moduleStores.erKitSelection ?? root.moduleStores.socialLinkErKitSelection!;
  const meoStore = root.moduleStores.meoKitSelection!;
  const enrollmentrKitSelectionStore = root.moduleStores.enrollmentKitSelection ?? root.moduleStores.socialLinkEntry!;

  const handleERPress = (value: boolean) => {
    erKitStore.updateEssentialRewards(value);
    if (erKitStore.useErSingleQuestion) {
      erKitStore.updateUsePremiumStarterKit(value);
    }
    if (meoStore) {
      meoStore.toggleWarningMessage(value);
    }
  };
  return (
    <>
      <YesNoQuestion
        onChange={value => handleERPress(value)}
        value={erKitStore.enrollEssentialRewards}
        question={t('AskIfEnrollInEssentialRewards')}
        whenYes={
          root.enrollmentStatus.countryIso !== 'HK' && root.enrollmentStatus.countryIso !== 'MO' ? (
            <ErYesMessage />
          ) : (
            <ErYesMessageNoLink />
          )
        }
        whenNo={t('EssentialRewardsIfNo')}
        err={!(meoStore?.canProceed() ?? true)}
      />
      {!erKitStore.useErSingleQuestion && erKitStore.showUsePremiumStarterKitQuestion && (
        <UsePremiumStarterKitQuestion />
      )}
      {meoStore?.orderRequiredModal && (
        <MeoWarning
          type={meoStore.getWarningType()}
          minimumEnrollmentPv={enrollmentrKitSelectionStore?.minimumEnrollmentOrderPv}
          minimumErPv={enrollmentrKitSelectionStore?.minimumErPv}
        />
      )}
    </>
  );
});
